import { render } from "./YinAudio.vue?vue&type=template&id=6ac816ac&scoped=true&ts=true"
import script from "./YinAudio.vue?vue&type=script&lang=ts"
export * from "./YinAudio.vue?vue&type=script&lang=ts"

import "./YinAudio.vue?vue&type=style&index=0&id=6ac816ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac816ac"]])

export default __exports__